/* Shahan Header - mobile drawer + search toggle */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('[data-shahan-drawer]');
    var openBtns = document.querySelectorAll('[data-shahan-drawer-open]');
    var closeBtns = document.querySelectorAll('[data-shahan-drawer-close]');
    var searchBar = document.querySelector('[data-shahan-search-bar]');
    var searchToggle = document.querySelector('[data-shahan-search-toggle]');

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });

    document.addEventListener('click', function (e) {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      var panel = drawer.querySelector('.shahan-drawer__panel');
      if (panel && !panel.contains(e.target) && !e.target.closest('[data-shahan-drawer-open]')) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });

    /* --- Wishlist page rendering --- */
    function renderWishlistPage() {
      var grid = document.querySelector('[data-shahan-wishlist-page]');
      if (!grid) return;
      var ids = [];
      try { ids = JSON.parse(localStorage.getItem('shahan_wishlist')) || []; } catch (e) {}
      var count = 0;
      grid.querySelectorAll('.shahan-wl-card').forEach(function (card) {
        var id = card.getAttribute('data-shahan-wl-id');
        if (ids.indexOf(id) !== -1) { card.hidden = false; count++; }
        else { card.hidden = true; }
      });
      var empty = grid.parentNode.querySelector('[data-shahan-wishlist-empty]');
      if (empty) empty.hidden = count > 0;
    }

    renderWishlistPage();
    document.addEventListener('shahan:wishlist-updated', renderWishlistPage);

    if (searchToggle && searchBar) {
      searchToggle.addEventListener('click', function () {
        searchBar.hidden = !searchBar.hidden;
        if (!searchBar.hidden) {
          var input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }
  });
})();
